export const DESKTOP_CARD_WIDTH = 204;
export const DESKTOP_COLUMNS_COUNT = 4;
export const DESKTOP_GRID_ROW_HEIGHT = 198;
export const DESKTOP_GRID_WIDTH = 838;
export const MOBILE_DEFAULT_COLUMN_WIDTH = 336;
export const MOBILE_LARGE_COLUMN_WIDTH = 466;
export const MOBILE_ROW_HEIGHT = 118;
export const MOBILE_SMALL_COLUMN_WIDTH = 300;
export const ROW_SPACE = 16;
